import { api } from "@/lib/api";

const rid = () => (crypto?.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);

function getVisitorId() {
  let v = localStorage.getItem("otelya_vid");
  if (!v) { v = rid(); localStorage.setItem("otelya_vid", v); }
  return v;
}

function getSession() {
  let s = sessionStorage.getItem("otelya_sid");
  if (!s) { s = rid(); sessionStorage.setItem("otelya_sid", s); sessionStorage.setItem("otelya_ref", document.referrer || ""); }
  return s;
}

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content"];

function getUtm(search) {
  const q = new URLSearchParams(search);
  if (UTM_KEYS.some((k) => q.get(k))) {
    const utm = Object.fromEntries(UTM_KEYS.map((k) => [k, q.get(k) || null]));
    sessionStorage.setItem("otelya_utm", JSON.stringify(utm));
  }
  const ref = q.get("ref");
  if (ref) localStorage.setItem("otelya_ref", ref);
  const p = q.get("ot_p");
  if (p) localStorage.setItem("otelya_pid", p);
  try { return JSON.parse(sessionStorage.getItem("otelya_utm") || "{}"); } catch { return {}; }
}

let lastTracked = { path: null, at: 0 };

export function trackPageview(location) {
  if (location.pathname.startsWith("/r/")) return;
  const now = Date.now();
  if (lastTracked.path === location.pathname && now - lastTracked.at < 1500) return;
  lastTracked = { path: location.pathname, at: now };
  try {
    const session_id = getSession();
    const utm = getUtm(location.search);
    api.post("/track/visit", {
      visitor_id: getVisitorId(),
      session_id,
      path: location.pathname,
      title: document.title,
      referrer: sessionStorage.getItem("otelya_ref") || null,
      prospect_id: localStorage.getItem("otelya_pid"),
      ...utm,
    }).catch(() => {});
  } catch { /* tracking must never break the site */ }
}
